import { useEffect } from 'react';

const useUnmount = (handler) => useEffect(() => handler, []);

export default useUnmount;
